import React from 'react';
import moment from 'moment';
import useStyles from './CustomTooltip.styles';

export interface CustomToolTipProps {
    subtext: string;
    active?: boolean;
    payload?: {
        payload: {
            date: Date;
        };
        value: any;
    }[];
}

const CustomTooltip: React.FC<CustomToolTipProps> = ({subtext, active, payload = []}) => {
    const styles = useStyles();

    if (!active) {
        return null;
    }

    const {value, payload: data} = payload[0] || {};
    const {date} = data || {};

    const formattedValue = isNaN(value) ? value : value.toLocaleString('en-US');

    return (
        <div className={styles.root}>
            <div className={`${'label' + ' '}${styles.label}`}>
                {date && <span className={styles.date}>{moment(date).format('ll')}</span>}
                {formattedValue !== null && (
                    <span className={styles.barValue}>{formattedValue}</span>
                )}
                {subtext && <span className={styles.subtext}>{subtext}</span>}
            </div>
        </div>
    );
};

export default CustomTooltip;
